/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sv } from './Sv';

class ClassroomCalendar extends Sv {
    constructor() {
        super();
        this.baseUrl += '/classroomCalendar';
    }

    data({ classroomName, beginTime, endTime, isAvailable, classroomCalendarType, currentPage, pageSize } = {}) {
        return super.get('/data', {
            classroomName,
            beginTime,
            endTime,
            isAvailable,
            classroomCalendarType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, classroomIds, beginTime, endTime, isAvailable, classroomCalendarType, certCatId, remarks } = {}) {
        return super.post('/save', {
            id,
            classroomIds,
            beginTime,
            endTime,
            isAvailable,
            classroomCalendarType,
            certCatId,
            remarks,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    classroomCalendarStat({ statDate, classroomName, classroomCalendarType, certCatId, currentPage, pageSize }) {
        let statDateBegin = null;
        let statDateEnd = null;
        if (statDate != null && statDate.length === 2) {
            [statDateBegin, statDateEnd] = statDate;
        }
        return super.get('/classroomCalendarStat', {
            statDateBegin,
            statDateEnd,
            classroomName,
            classroomCalendarType,
            certCatId,
            currentPage,
            pageSize,
        });
    }
}

export default new ClassroomCalendar();
export { ClassroomCalendar };
